import { createRouter, createWebHistory } from 'vue-router'
import langView from '../views/langView.vue'

const routes = [
  {
    path: '/',
    name: 'en',
    component: langView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
